export default __webpack_public_path__ + "static/media/mr-chung.515c9fa1.png";